import type { SharepointWorkbookRowsResponse } from '../types/SharepointWorkbookRows';

export const WORKSHEET_CACHE_TTL_MS = 15 * 60 * 1000;
export const WORKSHEET_FAILURE_CACHE_TTL_MS = 15 * 60 * 1000;
export const WORKBOOK_WORKSHEET_CACHE_SEP = '\u0000';

export type WorksheetCacheEntry = {
  body: SharepointWorkbookRowsResponse;
  at: number;
};

export type WorksheetFailureCacheEntry = {
  at: number;
};

export function worksheetCacheKey(
  documentUrl: string,
  worksheet: string | undefined
): string {
  return `${documentUrl}${WORKBOOK_WORKSHEET_CACHE_SEP}${worksheet ?? ''}`;
}

export function clearWorksheetCacheForDocument<T>(
  cache: Map<string, T>,
  documentUrl: string
): void {
  const prefix = `${documentUrl}${WORKBOOK_WORKSHEET_CACHE_SEP}`;
  for (const key of [...cache.keys()]) {
    if (key.startsWith(prefix)) {
      cache.delete(key);
    }
  }
}

export function cacheEntryIsFresh(
  entry: WorksheetCacheEntry,
  now = Date.now()
): boolean {
  return now - entry.at < WORKSHEET_CACHE_TTL_MS;
}

export function failureCacheEntryIsFresh(
  entry: WorksheetFailureCacheEntry,
  now = Date.now()
): boolean {
  return now - entry.at < WORKSHEET_FAILURE_CACHE_TTL_MS;
}
